import { createContext, useContext } from 'react';

import { FlowEventConfig } from '@zola/tracking-contracts/src/configs';
import { FlowCompleted, FlowStepCompleted } from '@zola/tracking-contracts/src/events';

export type FlowTrackingV2Values = {
  trackFlowStarted: () => void;
  trackFlowStepCompleted: (args: Omit<FlowStepCompleted, keyof FlowEventConfig>) => void;
  trackFlowCompleted: (args?: Omit<FlowCompleted, keyof FlowEventConfig>) => void;
};

const noopFunction = () => undefined;

export const DEFAULT_FLOW_TRACKING_V2_VALUES: FlowTrackingV2Values = {
  trackFlowStarted: noopFunction,
  trackFlowStepCompleted: noopFunction,
  trackFlowCompleted: noopFunction,
};

export const FlowTrackingV2Context = createContext<FlowTrackingV2Values>(
  DEFAULT_FLOW_TRACKING_V2_VALUES
);

export const useFlowTrackingV2 = () => useContext(FlowTrackingV2Context);
